import styled, { css } from 'styled-components';
import { Icon, loading } from '@web-chat-core/ui-kit';

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const Loading = styled(Icon)(
    () => css`
        margin: 0 16px 0 0;
        ${loading};
    `,
);
